<ng-container *ngIf="!loading">
  <h5 mat-dialog-title [attr.dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">{{ 'Contact.ContactDialog.Title' |
    translate }}</h5>
  <div mat-dialog-content class="f-s-14 lh-16" [attr.dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
    {{ 'Contact.ContactDialog.Message' | translate:{ contactType:displayContactType} }}
  </div>
  <div mat-dialog-actions class="p-24 p-t-0" [attr.dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <button mat-flat-button (click)="closeDialog()" cdkFocusInitial class="bg-error text-white m-x-6">{{'Shared.Cancel'
      | translate}}</button>
    <button mat-flat-button cdkFocusInitial (click)="doAction()">{{'Shared.OK' | translate}}</button>
  </div>
</ng-container>

<div class="justify-content-center align-items-center d-flex p-14" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>